module.exports = __webpack_public_path__ + "static/media/leprechaun-song.04c73bf3.gif";